import { AdvisorEditorSection } from './advisor-editor/AdvisorEditorSection';
import { WebinarLinkForm } from './WebinarLinkForm';
import { AdvisorAcceleratorLinkForm } from './AdvisorAcceleratorLinkForm';

export const FpSharedResourcesSection = () => (
  <div className="space-y-4">
    <AdvisorEditorSection title="Webinar Recordings" defaultOpen={false}>
      <WebinarLinkForm />
    </AdvisorEditorSection>
    <AdvisorEditorSection title="Advisor Accelerator" defaultOpen={false}>
      <AdvisorAcceleratorLinkForm />
    </AdvisorEditorSection>
  </div>
);
